import { useQuery } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL, IOrgBalanceResponse } from '@/dtos';

export const useOrganizationBalanceQuery = (orgId?: string | number) => {
  const { data, isLoading, refetch } = useQuery(
    [API_URL.OMNI_BALANCES_ORGANIZATIONS_BY_ORG_ID, orgId],
    () => {
      return api.get<IOrgBalanceResponse>(
        API_URL.OMNI_BALANCES_ORGANIZATIONS_BY_ORG_ID(orgId!)
      );
    },
    {
      enabled: Boolean(orgId),
    }
  );

  const statsData = data?.data;
  const logoUrl = statsData?.logo_info?.dark_minimized_logo_url || statsData?.logo_info?.minimized_logo_url;

  return {
    data: statsData,
    logoUrl,
    isLoading,
    refetch,
  };
};

export default useOrganizationBalanceQuery;
